import { useMutation } from "react-query";
import riskAssessmentService from "../../services/riskAssessmentService";

const useAddRiskAssessment = () => useMutation(riskAssessmentService.addRiskAssessment);

export default useAddRiskAssessment;
